import { typographyStyles } from "@newsela/angelou";
import { CSSObject } from "@emotion/react";

const { textXSObj } = typographyStyles;

export const drawersCss: CSSObject = {
  listStyle: "none",
  margin: 0,
  padding: 0,
  "& > li": {
    marginBottom: "1em",
    "&:last-child": {
      marginBottom: 0,
    },
  },
};

export const sectionCss: CSSObject = {
  paddingTop: ".5em",
  display: "flex",
  flexDirection: "row",
  justifyContent: "space-between",
  "text-transform": "uppercase",
  ...textXSObj,
  /* if there is only one child the toggle buttons should remain right aligned and the label (h3) should remain left aligned */
  "& > *:only-child:not(h3)": {
    marginLeft: "auto",
  },
  "> h3": {
    ...textXSObj,
  },
};
